import RNSlider from "@react-native-community/slider";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Platform, View } from "react-native";
import Animated, { useAnimatedStyle, useSharedValue, withSpring } from "react-native-reanimated";
import { Text } from "../../atoms/text/Text";
import { style as sliderStyle } from "./Slider.style";
const SPRING_CONFIG = {
    damping: 20,
    stiffness: 300,
};
const Slider = ({ value, min, max, steps, tradename, style: customStyle, onChange, onSlidingComplete, formatValue = (value) => value, }) => {
    const style = useMemo(() => sliderStyle({ tradename }), [tradename]);
    const [currentValue, setCurrentValue] = useState(value);
    const sliderWidth = useSharedValue(0);
    const textWidth = useSharedValue(0);
    const sliderPosition = useSharedValue(((value - min) / (max - min)) * 100);
    const calculatePercentage = useCallback((val) => ((val - min) / (max - min)) * 100, [min, max]);
    useEffect(() => {
        setCurrentValue(value);
        sliderPosition.value = withSpring(calculatePercentage(value), SPRING_CONFIG);
    }, [value, calculatePercentage, sliderPosition]);
    const handleValueChange = useCallback((newValue) => {
        setCurrentValue(newValue);
        sliderPosition.value = calculatePercentage(newValue);
        onChange(newValue);
    }, 
    // oxlint-disable-next-line react/exhaustive-deps
    [onChange, calculatePercentage]);
    const handleSlidingComplete = useCallback((newValue) => {
        setCurrentValue(newValue);
        sliderPosition.value = withSpring(calculatePercentage(newValue), SPRING_CONFIG);
        onSlidingComplete?.(newValue);
    }, 
    // oxlint-disable-next-line react/exhaustive-deps
    [onSlidingComplete, calculatePercentage]);
    const handleSliderLayout = useCallback((event) => {
        sliderWidth.value = event.nativeEvent.layout.width;
    }, [sliderWidth]);
    const handleTextLayout = useCallback((event) => {
        const width = event.nativeEvent.layout.width;
        if (width > 0 && width !== textWidth.value) {
            textWidth.value = width;
        }
    }, [textWidth]);
    const animatedStyle = useAnimatedStyle(() => {
        const percentage = sliderPosition.value / 100;
        const isAndroid = Platform.OS === "android";
        const availableWidth = isAndroid ? sliderWidth.value : sliderWidth.value - style.thumbSize;
        const offset = isAndroid ? 0 : style.thumbSize / 2;
        const thumbCenterPosition = availableWidth * percentage + offset;
        const textCenteredPosition = thumbCenterPosition - textWidth.value / 2;
        return { left: textCenteredPosition };
        // oxlint-disable-next-line react/exhaustive-deps
    }, []);
    return (React.createElement(View, { style: style.sliderContainer, onLayout: handleSliderLayout },
        React.createElement(Animated.View, { style: [style.thumbTextContainer, animatedStyle] },
            React.createElement(Text, { numberOfLines: 1, style: style.thumbText, variant: "detail", onLayout: handleTextLayout }, formatValue(currentValue))),
        React.createElement(RNSlider, { maximumTrackTintColor: style.secondaryColor, maximumValue: max, minimumTrackTintColor: style.primaryColor, minimumValue: min, step: steps ? (max - min) / steps : undefined, style: [style.track, customStyle], testID: "slider", thumbTintColor: style.primaryColor, value: value, onSlidingComplete: handleSlidingComplete, onValueChange: handleValueChange })));
};
export { Slider };
